/* ==========================================================================
   Internal Security Page (PORTAL-187)
   The signed-in super admin's own two-factor settings. Also protects the
   /admin-panel login, which asks for the same code once 2FA is on.
   ========================================================================== */

import { TwoFactorSettingsCard } from '@/components/auth/TwoFactorSettingsCard'
import {
  getInternalTwoFactorStatus,
  startInternalTwoFactorSetup,
  enableInternalTwoFactor,
  disableInternalTwoFactor,
} from '@/api/internal'

// Module-level so the card's status fetch runs once, not on every render.
const twoFactorApi = {
  getStatus: getInternalTwoFactorStatus,
  startSetup: startInternalTwoFactorSetup,
  enable: enableInternalTwoFactor,
  disable: disableInternalTwoFactor,
}

export function Security() {
  return (
    <div className="py-12">
      <div className="max-w-lg mx-auto px-4 sm:px-6 lg:px-8">
        <h1 className="font-serif text-2xl sm:text-3xl text-charcoal mb-2 text-center">
          Security
        </h1>
        <p className="text-center text-charcoal/70 mb-8">
          Two-factor authentication for the internal tools and the admin panel.
        </p>
        <TwoFactorSettingsCard api={twoFactorApi} />
      </div>
    </div>
  )
}

export default Security
